'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Data types.
 *
 * @export
 * @enum {string}
 */
var DataType = /*#__PURE__*/function (DataType) {
  DataType["Int"] = "Integer";
  DataType["Real"] = "Real";
  DataType["String"] = "String";
  DataType["Bool"] = "Boolean";
  DataType["Datetime"] = "Datetime";
  DataType["VertexOrEdge"] = "Vertex or Edge";
  DataType["Collection"] = "Collection";
  DataType["Unknown"] = "Unknown";
  return DataType;
}({});

exports.DataType = DataType;
